import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPost, apiPut, apiDel } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getSurveysFromAPI = async (token) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet('/surveys', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const getSurveyDetailFromAPI = async (token, survey_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/surveys/${survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const getPredefinedSurveysFromAPI = async (token, obj) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();
    obj["encryptedKey"] = encryptedAESKey;

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: obj,
    };

    const response = await apiGet('/surveys', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const addSurveyFromAPI = async (token, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPost('/surveys', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const updateSurveyFromAPI = async (token, obj, survey_id) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPut(`/surveys/${survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const deleteSurveyFromAPI = async (token, survey_id) => {
    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
    };

    return await apiDel(`/surveys/${survey_id}`, requestInfo);
};

export const sendSurveyFromAPI = async (token, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPost('/surveys/sendSurvey', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
